export default function populateChoices({ selected, names, isFirst }) {
  const arr = [
    {
      label: names?.firstName?.name,
      value: names?.firstName?.name,
      isFirst: true,
      selected: selected && isFirst && selected === names?.firstName?.name,
    },
  ]

  if (names?.middleNames && names?.middleNames?.length > 0) {
    names?.middleNames?.forEach((parsedName) => {
      arr.push({
        label: parsedName?.name,
        value: parsedName?.name,
        isFirst: true,
        selected: selected && isFirst && selected === parsedName?.name,
      })
    })
  }
  if (names?.lastName) {
    arr.push({
      label: names?.lastName?.name,
      value: names?.lastName?.name,
      isFirst: false,
      selected: selected && !isFirst && selected === names?.lastName?.name,
    })
  }
  return arr
}
